export default function Noise() {
  return <div className="grain-overlay" aria-hidden="true" />;
}
